export default {
    "total_wine": "藏酒總數",
    "bottle": "瓶",
    "values": "藏酒價值",
    "total_cost": "總成本",
    "temperature": "酒窖溫度",
    "humidity": "酒窖濕度",
    "filter_wine_list": "縮小藏酒顯示範圍",
    "reset": "重設",
    "filter": "篩選",
    "search_wine": "搜尋酒名",
    "sort_recently": "最近更動",
    "sort_highest_value": "價值最高",
    "sort_lowest_value": "價值最低",
    "sort_highest_profit": "獲利最高",
    "sort_highest_losses": "損失最多",
    "sort_maximun_stock": "最多存量",
    "sort_highest_rating": "最高評價",
    "sort_lowest_rating": "最低評價",
    "check_matching_wines": "查看比對中藏酒",
    "matching_list": "比對中列表",
    "import_completed": "已匯入",
    "price_per_bottle": "每瓶單價",
    "edit_member_wine": "編輯藏酒",
    "purchase_note": "購買筆記",
    "unit_price": "每瓶價格",
    "remove_all": "全部移除",
    "remove": "移除",
    "got_to_shipping": "去托運"
}